import {
  RemoveMemberDocument,
  RemoveMemberMutation,
  RemoveMemberMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useRemoveMember = () => {
  const [mutation, { loading }] = useMutation(RemoveMemberDocument, {
    extractorFn: (data: RemoveMemberMutation) => data.teamsMutations.deleteTeamsMembership,
  })

  const removeMember = (variables: RemoveMemberMutationVariables) => {
    return mutation({
      variables,
      update(cache) {
        cache.evict({ id: cache.identify({ __typename: 'TeamsMembership', id: variables.id }) })
        cache.gc()
      },
    })
  }

  return { loading, removeMember }
}

export default useRemoveMember
